<template>
  <div>
    <div v-if="!isShowVideo" class="stay_tuned video_position">
      <img
        class="stay_tuned_image"
        src="../../assets/news/staytuned.png"
        alt="敬 请 期 待 ......"
      />
    </div>
    <div v-if="isShowVideo">
      <!-- 直播 -->
      <div v-if="!isShowControls">
        <button
          class="video_play_pause video_position"
          v-if="isShowPlay"
          @click="playEvent"
          poster="../../assets/news/cover.png"
        >
          <img
            class="video_play_pause_image"
            src="../../assets/news/play.png"
          />
        </button>
        <button class="video_bg video_position" @click="isShowPlayEvent">
          <video
            ref="video"
            id="video"
            class="video"
            x5-video-player-type="h5"
            webkit-playsinline="false"
            src="https://t.cherry.cn/upload/users/ma/20201031/output.mp4"
            controlsList="nodownload noremote footbar"
            playsinline="true"
            x-webkit-airplay="true"
            x5-video-orientation="portraint"
            disablepictureinpicture="false"
            x5-playsinline="true"
            poster="../../assets/news/cover.png"
          ></video>
        </button>
      </div>
      <!-- 视频 -->
      <div class="video_bg video_position" v-if="isShowControls">
        <!-- x5-video-player-fullscreen="true" 防止横屏 -->
        <video
          ref="video"
          id="video"
          class="video"
          controls
          controlsList="nodownload noremote footbar"
          webkit-playsinline="true"
          playsinline="true"
          x-webkit-airplay="true"
          x5-video-orientation="portraint"
          disablepictureinpicture="false"
          x5-playsinline="true"
          x5-video-player-type="h5"
          src="https://t.cherry.cn/upload/users/ma/20201031/output_001_short.mp4"
          poster="../../assets/news/cover.png"
        ></video>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { VideoConfig } from "../video/VideoConfig";
@Options({
  props: {
    width: String,
    height: String
  }
})
export default class Video extends Vue {
  $refs!: {
    div: HTMLDivElement;
    video: HTMLVideoElement;
    canvas: HTMLCanvasElement;
    progress: HTMLProgressElement;
  };
  // 是否显示视频
  private isShowVideo = true;
  // 是否显示Controls
  private isShowControls = false;
  // 是否显示播放页面
  private isShowPlay = true;
  private timerInterval: number | null = 0;
  private automaticTimer: number | null = 0;
  private videoDuration = 0;
  mounted() {
    this.setIntervalReloadData();
    this.creatVideo();
  }
  creatVideo() {
    this.isShowVideo = !this.noLive();
    if (this.isShowVideo) {
      this.$refs.video.addEventListener("ended", () => {
        this.isShowControls = true;
      });
    }
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    this.timerInterval = setInterval(() => {
      if (self.timerInterval != null) {
        clearTimeout(self.timerInterval);
      }
      self.videoStatus();
    }, 500);
  }
  // 自动播放
  play() {
    this.playEvent();
    document.addEventListener(
      "WeixinJSBridgeReady",
      function() {
        const vid = document.getElementById("video") as HTMLVideoElement;
        vid.play();
      },
      false
    );
  }

  // 距离直播3分钟就倒计时
  setIntervalReloadData() {
    const now = new Date();
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const seconds = VideoConfig.statusTimer - now.getTime();
    if (seconds < 180000 && seconds > 0) {
      self.timerInterval = setInterval(() => {
        if (self.timerInterval != null) {
          clearTimeout(self.timerInterval);
        }
        self.playEvent();
      }, seconds + 3000);
    }
  }

  isShowPlayEvent() {
    this.playEvent();
  }
  playEvent() {
    this.isShowPlay = !this.isShowPlay;
    if (!this.isShowPlay) {
      this.videoStatus();
      this.$refs.video.play();
    } else {
      this.$refs.video.pause();
    }
  }
  videoStatus() {
    /// 播中
    if (this.liveStreaming()) {
      this.isShowControls = false;
      const vid = document.getElementById("video") as HTMLVideoElement;
      vid.currentTime = this.currentTime();
    }
    // 播完
    else if (this.liveBroadcast()) {
      this.isShowControls = true;
    }
  }
  pauseEvent() {
    this.$refs.video.pause();
  }
  /// 未播
  noLive(): boolean {
    const now = new Date();
    const nowTimer = now.getTime();
    if (nowTimer < VideoConfig.statusTimer) {
      return true;
    }
    return false;
  }
  /// 播中
  liveStreaming(): boolean {
    const now = new Date();
    const nowTimer = now.getTime();
    // 直播总时间 = 总时长 + (视频时间*每分钟的时间戳)
    // const liveTotalTimer =
    //   VideoConfig.statusTimer +
    //   this.$refs.video.duration * VideoConfig.minutesTimestamp;
    const liveTotalTimer = VideoConfig.liveendTimer;
    // 当前时间大于开始时间 && 当前时间小于直播时间
    if (nowTimer > VideoConfig.statusTimer && nowTimer < liveTotalTimer) {
      return true;
    }
    return false;
  }
  /// 播完
  liveBroadcast(): boolean {
    const now = new Date();
    const nowTimer = now.getTime();
    // 直播总时间 = 总时长 + (视频时间*每分钟的时间戳)
    // let liveTotalTimer =
    //   VideoConfig.statusTimer +
    //   this.$refs.video.duration * VideoConfig.minutesTimestamp;
    const liveTotalTimer = VideoConfig.endTimer;
    // 当前时间大于直播时间
    if (nowTimer > liveTotalTimer) {
      return true;
    }
    return false;
  }
  // 播放时长
  currentTime(): number {
    // const videoDuration = this.$refs.video.duration;
    const videoDuration = 4811.4;
    const now = new Date().getTime();
    // 总时间
    const liveTotalTimer =
      VideoConfig.statusTimer + videoDuration * VideoConfig.minutesTimestamp;
    // 剩余时间
    const lastTimer = (liveTotalTimer - now) / VideoConfig.minutesTimestamp;
    const currentTime = videoDuration - lastTimer;
    return currentTime;
  }
}
</script>

<style scoped lang="less">
@import "../../style/BaseStyle.less";
.video_position {
  top: 80px;
  border-radius: 8px;
}
.stay_tuned {
  position: absolute;
  top: 80px;
  width: 100%;
  height: 220px;
  line-height: 220px;
  background-color: rgba(0, 0, 0, 1);
  font-weight: bold;
  font-size: 18px;
  color: white;
  .stay_tuned_image {
    margin-top: 20px;
    width: 80%;
    text-align: center;
  }
}
.video {
  width: 100%;
  height: 220px;
  float: left;
  border-radius: 8px;
  border: 0px solid transparent;
}
.video_bg {
  top: 80px;
  position: relative;
  border-radius: 8px;
  background-color: #222222;
  height: 220px;
  width: 100%;
  outline: none;
  border: 0px solid transparent;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}
.video_play_pause {
  float: left;
  position: absolute;
  background-color: rgba(17, 17, 17, 0.1);
  height: 240px;
  width: 100%;
  outline: none;
  z-index: 1000;
  border: 0px solid transparent;
  -webkit-tap-highlight-color: rgba(17, 17, 17, 0.1);
  -webkit-tap-highlight-color: transparent;
  .video_play_pause_image {
    text-align: center;
    width: 80px;
    height: 80px;
  }
}
// video::-webkit-media-controls-play-button,
// video::-webkit-media-controls-pause-button {
//   width: 56px;
//   height: 56px;
// }
#video {
  object-fit: fill;
}
/*video默认aduio音量按钮*/
video::-webkit-media-controls-mute-button {
  display: none !important;
}
/*video默认setting按钮*/
video::-webkit-media-controls-overflow-button {
  display: none !important;
}
/*video默认全屏按钮*/
// video::-webkit-media-controls-fullscreen-button {
//   display: none !important;
// }
// // 隐藏video 当前按钮
// video::-webkit-media-controls-current-time-display {
//   display: none !important;
// }
// // 隐藏video 总时间
// video::-webkit-media-controls-time-remaining-display {
//   display: none !important;
// }
</style>
